export default function ExportIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_4748_15353'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='20'
        height='20'
      >
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_4748_15353)'>
        <path
          d='M4.43615 17.0964C4.01517 17.0964 3.65885 16.9505 3.36719 16.6589C3.07552 16.3672 2.92969 16.0109 2.92969 15.5899V12.6253H4.17969V15.5899C4.17969 15.6541 4.20642 15.7128 4.2599 15.7661C4.31323 15.8196 4.37198 15.8464 4.43615 15.8464H15.5899C15.6541 15.8464 15.7128 15.8196 15.7661 15.7661C15.8196 15.7128 15.8464 15.6541 15.8464 15.5899V4.43615C15.8464 4.37198 15.8196 4.31323 15.7661 4.2599C15.7128 4.20642 15.6541 4.17969 15.5899 4.17969H4.43615C4.37198 4.17969 4.31323 4.20642 4.2599 4.2599C4.20642 4.31323 4.17969 4.37198 4.17969 4.43615V7.40073H2.92969V4.43615C2.92969 4.01517 3.07552 3.65885 3.36719 3.36719C3.65885 3.07552 4.01517 2.92969 4.43615 2.92969H15.5899C16.0109 2.92969 16.3672 3.07552 16.6589 3.36719C16.9505 3.65885 17.0964 4.01517 17.0964 4.43615V15.5899C17.0964 16.0109 16.9505 16.3672 16.6589 16.6589C16.3672 16.9505 16.0109 17.0964 15.5899 17.0964H4.43615ZM8.90719 13.7309L8.02906 12.8272L10.2182 10.638H2.92969V9.38802H10.2182L8.02906 7.19885L8.90719 6.2951L12.6251 10.013L8.90719 13.7309Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
